import React, { type FC } from 'react'
import RadioGroupItem from '@mobi/component-library/Selection&Input/CheckboxAndRadioGroups/RadioGroupItem'
import { BlackbookAlertPromptStyled, RadioGroup } from './BlackbookAlertPrompt.styled'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Icon } from '@mobi/component-library/Assets/Icon'

type AlertMethod = 'push' | 'sms'

type BlackbookAlertPromptProps = {
  /**
   * Callback when the alert method is chosen
   */
  onAlertMethodChosen?: (method: AlertMethod) => void
  /**
   * Callback when the prompt is closed
   */
  onClose?: VoidFunction
  /**
   * Test ID for testing automation purposes
   */
  'data-testid': string
}

export const BlackbookAlertPrompt: FC<BlackbookAlertPromptProps> = ({
  onAlertMethodChosen,
  onClose,
  'data-testid': testId,
}) => {
  const [alertMethod, setAlertMethod] = React.useState<AlertMethod>('push')

  return (
    <BlackbookAlertPromptStyled data-testid={testId}>
      <header>
        Blackbook <br />
        Notifications Are Here&nbsp;⏰
      </header>

      <div className='description'>
        <div className='description-icon'>
          <Icon name='DuocolorClock' size='4.2rem' />
        </div>
        <div>
          <div className='description-title'>
            Stay in the Loop with Blackbook Push Notifications!
          </div>
          Get the most out of your BlackBook favourites with daily reminders delivered directly from
          your app! Never miss a thing with the faster, more secure push notifications.
        </div>
      </div>

      <div className='selection-methods' data-testid='blackbook-notification-prompt-selections'>
        <div className='selection-methods-title'>How would you like to receive notifications?</div>
        <RadioGroup>
          <RadioGroupItem
            id='push-notification-method'
            size='sm'
            iconName='LineNotificationBox'
            isChecked={alertMethod === 'push'}
            badgeText='New'
            badgeColor='error'
            onClick={() => setAlertMethod('push')}
          >
            Push Notification
          </RadioGroupItem>
          <RadioGroupItem
            id='sms-notification-method'
            size='sm'
            iconName='LineMessageTextSquare02'
            isChecked={alertMethod === 'sms'}
            onClick={() => setAlertMethod('sms')}
          >
            SMS
          </RadioGroupItem>
        </RadioGroup>
      </div>

      <footer>
        <Button
          data-testid='blackbook-alert-prompt-confirm'
          isFullWidth
          size='lg'
          onClick={() => onAlertMethodChosen?.(alertMethod)}
        >
          Confirm
        </Button>
        <br />
        <Button
          data-testid='blackbook-alert-prompt-close'
          isFullWidth
          color='tertiary_grey'
          size='sm'
          onClick={onClose}
        >
          Close
        </Button>
      </footer>
    </BlackbookAlertPromptStyled>
  )
}
